<!--
 * @Author: lsh
 * @Date: 2021-03-01 14:38:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-23 15:28:07
 * @Descripttion: 
 * @FilePath: \scwater_development\src\views\projectOnly\investManage\components\InvestPlan.vue
-->
<template>
  <div>
    <div class="count-wrap">
      <div class="item" v-for="(item, index) in tapData" :key="index">
        <el-popover placement="right" width="180" trigger="hover">
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '总投资'"
          >
            计划总投资{{ item.num }}万元
          </div>
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '累计下达投资'"
          >
            累计下达投资{{ item.num }}万元
          </div>
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '当年计划投资'"
          >
            <p>
              <i class="blue"></i>中央投资： <b>{{ tapDtData.jhZytz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>省级投资： <b>{{ tapDtData.jhSjtz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>地方投资： <b>{{ tapDtData.jhDftz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>其他： <b>{{ tapDtData.jhQt }}</b
              >万元
            </p>
          </div>
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '累计完成投资'"
          >
            <p>
              <i class="blue"></i>中央投资： <b>{{ tapDtData.ljZytz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>省级投资： <b>{{ tapDtData.ljSjtz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>地方投资： <b>{{ tapDtData.ljDftz }}</b
              >万元
            </p>
            <p>
              <i class="blue"></i>其他： <b>{{ tapDtData.ljQt }}</b
              >万元
            </p>
          </div>
          <div
            style="text-align: left; margin: 0"
            v-show="item.name == '计划投资完成率'"
          >
            计划投资完成率=累计完成投资/计划总投资
          </div>
          <div slot="reference" class="num-wrap">
            <div>{{ item.name }}</div>
            <div>
              <b :class="item.cls">{{ item.num }}</b>
              {{ item.unit }}
            </div>
          </div>
        </el-popover>
        <img :src="item.img" alt />
      </div>
    </div>
    <div class="warp-box box_shadow">
      <div class="select-wrap">
        <span class="demonstration">年份选择：</span>
        <el-date-picker
          v-model="year"
          type="year"
          placeholder="选择年份"
          @change="closeeditdialog"
          style="width: 217px; margin-right: 20px"
          value-format="yyyy"
          format="yyyy"
          :clearable="false"
        ></el-date-picker>
        <el-button
          type="primary"
          @click="editTable('编辑')"
          style="margin-right: 10px"
          >编辑</el-button
        >
        <!-- <el-button type="primary" plain style="margin-right: 10px" @click="importExcel()">导入</el-button> -->
        <el-button
          type="primary"
          plain
          style="margin-right: 10px"
          @click="exportData()"
          >导出</el-button
        >
      </div>
      <div class="total-wrap">
        <i class="el-icon-warning-outline"></i>
        本年度计划总投资：
        <b>{{ countData.total }}</b
        >万元 其中中央投资： <b>{{ countData.center }}</b
        >万元，省级投资： <b>{{ countData.province }}</b
        >万元，地方投资： <b>{{ countData.local }}</b
        >万元，其他： <b>{{ countData.other }}</b
        >万元
      </div>
      <div class="year-wrap tb_wrapper" v-loading="loading">
        <el-table :data="yearList" style="width: 100%">
          <el-table-column
            prop="planMonth"
            align="center"
            label="月份"
            width="180"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.planMonth }}月</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalCount"
            label="总投资(万元)"
            align="right"
            sortable
          >
            <template slot-scope="scope">
              <span style="padding-right: 30px">
                {{ scope.row.totalCount || 0 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="zytz"
            label="中央投资(万元)"
            align="right"
            sortable
          >
            <template slot-scope="scope">
              <span style="padding-right: 30px">{{ scope.row.zytz || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sjtz"
            label="省级投资(万元)"
            align="right"
            sortable
          >
            <template slot-scope="scope">
              <span style="padding-right: 30px">{{ scope.row.sjtz || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="dftz"
            label="地方投资(万元)"
            align="right"
            sortable
          >
            <template slot-scope="scope">
              <span style="padding-right: 30px">{{ scope.row.dftz || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="qt" label="其他(万元)" align="right" sortable>
            <template slot-scope="scope">
              <span style="padding-right: 30px">{{ scope.row.qt || 0 }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      :title="'投资计划填报'"
      class="common_table_dialog"
      :visible.sync="showEditCardDialog"
      v-if="showEditCardDialog"
      :close-on-click-modal="false"
      width="1000px"
      top="30px"
    >
      <plan-edit
        @closeeditdialog="closeeditdialog"
        :yearList="yearList"
        :yearLength="yearLength"
        :tapDtData="tapDtData"
        :year="year"
      ></plan-edit>
    </el-dialog>
    <!-- <import-data
      v-if="showImportDialog"
      :showImportDialog="showImportDialog"
      leadInUrl="/mgt/bsProjPlanInvest/excelToPlanInvest"
      downloadTemplate="计划投资导入模板.xlsx"
      @closeImportDialog="closeImportDialog"
    />-->
  </div>
</template>

<script>
import { investPlanApi } from "@/api/projectOnly";
import planEdit from "./planDialog";
export default {
  name: "InvestPlan",
  components: { planEdit },
  data() {
    return {
      showImportDialog: false,
      tapData: [
        {
          name: "总投资",
          img: require("../../../../assets/images/invest-icon-01.png"),
          num: 0,
          unit: "万元",
          cls: "c1",
        },
        {
          name: "累计下达投资",
          img: require("../../../../assets/images/invest-icon-04.png"),
          num: 0,
          unit: "万元",
          cls: "c1",
        },
        {
          name: "累计完成投资",
          img: require("../../../../assets/images/invest-icon-03.png"),
          num: 0,
          unit: "万元",
          cls: "c2",
        },
        {
          name: "计划投资完成率",
          img: require("../../../../assets/images/invest-icon-05.png"),
          num: 0,
          unit: "%",
          cls: "c3",
        },
      ],
      tapDtData: {},
      year: new Date().format("yyyy"),
      countData: {
        total: 0,
        center: 0,
        province: 0,
        local: 0,
        other: 0,
      },
      yearList: [],
      yearLength: [],
      showEditCardDialog: false,
      loading: true,
    };
  },
  created() {},
  mounted() {
    this.getYear();
    this.getCount();
  },
  methods: {
    closeImportDialog(type) {
      if (type == 1) {
        this.getList();
      } else {
        this.showImportDialog = false;
      }
    },
    importExcel() {
      this.showImportDialog = true;
    },
    exportData() {
      let token = this.$localData("get", "userInfo").token;
      let exportUrl =
        this.$config.baseUrl +
        "/mgt/bsProjPlanInvest/listToExcel" +
        "?token=" +
        token +
        "&projCode=" +
        this.$store.state.projectDetail.code +
        "&planYear=" +
        this.year;
      window.open(exportUrl);
    },
    getList() {
      investPlanApi
        .list({
          projCode: this.$store.state.projectDetail.code,
          planYear: this.year,
        })
        .then((res) => {
          this.yearList = res.data.list;
          // console.log(this.yearList[0].planMonth, "15131");
          this.yearLength = res.data.month.data;
        });
    },
    getYear() {
      investPlanApi
        .year({
          projCode: this.$store.state.projectDetail.code,
        })
        .then((res) => {
          if (res.success) {
            let data = res.data;
            let l = res.data.length;
            if (l > 0) {
              // this.year = data[l-1].substring(0,4)
              this.getList();
            } else {
              this.$message.error("当前工程无项目截止年度！");
            }
          }
        });
    },
    getCount() {
      this.loading = true;
      investPlanApi
        .count({
          projCode: this.$store.state.projectDetail.code,
          planYear: this.year,
        })
        .then((res) => {
          console.log(res, "---");

          this.tapData[0].num = res.data.gsztz;
          this.tapData[1].num = res.data.ljXdtz;
          this.tapData[2].num = res.data.ljZtz;
          this.tapData[3].num = res.data.tzl;
          this.countData.total = res.data.jhDntz;
          this.countData.center = res.data.jhZytz;
          this.countData.province = res.data.jhSjtz;
          this.countData.local = res.data.jhDftz;
          this.countData.other = res.data.jhQt;
          this.tapDtData = res.data;
          this.tapDtData.jhztz = this.$store.state.projectDetail.code;
          if (res.success) {
            this.loading = false;
          }
        });
    },
    editTable() {
      this.showEditCardDialog = true;
    },
    closeeditdialog() {
      this.showEditCardDialog = false;
      this.getList();
      this.getCount();
    },
  },
};
</script>
<style lang="scss" scoped>
.count-wrap {
  padding-top: 20px;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  position: relative;
  .item {
    width: 24%;
    display: flex;
    justify-items: center;
    justify-content: space-between;
    align-items: center;
    padding: 2% 1%;
    background: #fff;
    box-shadow: 0 0 15px 0 rgba(66, 75, 113, 0.1);
    font-size: 16px;
    color: #333333;
    letter-spacing: 1.33px;
    box-sizing: border-box;
    .icon {
      position: absolute;
      right: 24px;
      top: 26px;
      background: url("../../../../assets/images/question.png");
      width: 14px;
      height: 14px;
      display: inline-block;
    }
    .num-wrap {
      > div:nth-child(1) {
        font-size: 16px;
        color: #333333;
        padding-bottom: 13px;
      }
    }
    b {
      font-size: 30px;
      &.c1 {
        color: #008dfe;
      }
      &.c2 {
        color: #f77671;
      }
      &.c3 {
        color: #89d572;
      }
    }
  }
}
.select-wrap {
  padding-bottom: 16px;
}
.box_shadow {
  background: #ffffff;
  box-shadow: 0 0 15px 0 rgba(66, 75, 113, 0.1);
  border-radius: 4px;
}
.warp-box {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: 24px;
}
.total-wrap {
  height: 48px;
  background: #eef7ff;
  line-height: 48px;
  padding-left: 30px;
  margin-bottom: 26px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.48);
  b {
    font-size: 20px;
    color: #18a1ff;
    font-weight: 700;
  }
  i {
    color: #008dfe;
  }
}
.year-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0;
  div {
    width: 25%;
    box-sizing: border-box;
    text-align: center;
    .tit {
      width: 100%;
      background: #edf3f9;
      color: #333;
      padding: 20px 0;
      border-right: 1px solid #d6d2cc;
      border-bottom: 1px solid #d6d2cc;
    }
    .tit1,
    .tit2,
    .tit3,
    .tit4 {
      border-top: 1px solid #d6d2cc;
    }
    .tit1,
    .tit5,
    .tit9,
    .content1,
    .content5,
    .content9 {
      border-left: 1px solid #d6d2cc;
    }
    .content {
      width: 100%;
      background: #fff;
      color: #008dfe;
      padding: 44px 0;
      height: 112px;
      border-right: 1px solid #d6d2cc;
      border-bottom: 1px solid #d6d2cc;
      div {
        width: 100%;
        cursor: pointer;
        text-align: center;
      }
      .text {
        color: #333;
        b {
          font-size: 24px;
          color: #008dfe;
          letter-spacing: 2px;
        }
      }
    }
  }
}
.ignore-wrap {
  i.blue {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: #008dfe;
    vertical-align: 2px;
    margin-right: 4px;
  }
  b {
    color: #008dfe;
    margin-right: 4px;
  }
  p {
    line-height: 24px;
  }
}
</style>
